/*
The magic here is a bit obfuscated...
Three main steps take place:
#1 Center of original object is captured with respect to original aspect ratio (coordinate system) 
#2 Object is scaled. Scaling shrinks object (or grows) from Top Left
#3 Center of new object is captured
#4 The "target" of where center of new object is calculated by taking percent difference from top and left (same as % diff from orig dimensions)
#5 The new object is translated by difference of old center (with respect to coord system) and the new target center. 
#6 Apply background to image getting watermark applied.. This is much quicker than using Jimp, however there is slight quality loss. 
*/ 

// Override fabric toObject to use dataURL so image is actually saved to JSON
fabric.Image.prototype.toObject = (function (toObject) {
  return function () {
      var image = this;

      var getData = function () {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext('2d');
          context.drawImage(image.getElement(), 0, 0);
          return canvas.toDataURL('image/png').replace(/^data:image\/png;base64,/, '');
      };
      return fabric.util.object.extend(toObject.call(this), {
          dataURL: getData(),
      });
  };
})(fabric.Image.prototype.toObject);

// must use callback if you are doing simpleComposite!
// compositeBackgroundImage and callback are not required
// origWidth and origHeight represent original width of WM. newW and newH are image dims being applied to
function fit(json, origWidth, origHeight, newWidth, newHeight, outputType, outputQuality = 1, compositeBackgroundImage, callback) {

  
  
  // NEED TO CHECK HERE >>> MULTIPLE CANVAS' ARE EXPENSIVE AND UNNECESSARY >> SHOULD CONSIDER RE-USING !!!!

  // instantiate Fabric canvas
  var newCanvas = document.createElement('canvas');
  // explicitly set dimensions to make sure there's no funny business when loading Fabric JSON obj

  var fitCanvas = new fabric.StaticCanvas(newCanvas);
  fitCanvas.setHeight(newHeight);
  fitCanvas.setWidth(newWidth);
  fitCanvas.lowerCanvasEl.width=newWidth
  fitCanvas.lowerCanvasEl.height=newHeight

  // load Fabric JSON to canvas
  // 1) wait for images and json to load to Fabric, then use callback to:
  // 2) call positionElements() promise
  // 3) then compositeImages ()
  fitCanvas.loadFromJSON(json, function() {
    fitCanvas.renderAll.bind(fitCanvas)
    positionElements().then(() => {
      compositeImages()
    })
    .catch(error => {
      // Error
      console.log(error);
    });
  });

  function positionElements() {
    return new Promise((resolve, reject) => {

    /* TESTING
    var newWindow = window.open();
    newWindow.document.write('<p>' + 'origWidth: ' + origWidth, ', orignHeight: ' + origHeight + ', newWidth: ' + newWidth, ', newHeight: ' + newHeight + '</p>')
    newWindow.document.write('<img style="border: 1px solid black" src="' + fitCanvas.toDataURL('image/png') + '"/>');
    */

    // get scale factor 
    let scaleXFactor = newWidth / origWidth 

    // get all canvas objects
    let objs = fitCanvas.getObjects();
    
    // this threshold makes positioning sticky towards the side
    // if user snuggles an object next to the corner/side, they want it to be near the corner/side
    let staticThreshold = 0.10;

    for (var i in objs) {
      
      // TESTING 
      // newWindow.document.write('</br>' + 'aCoords before: ' + JSON.stringify(objs[i].aCoords) + '</br>')

      //
      // --- LOCATION --- 
      //
      
      // (I TL, II TR, III BL, IV BR) with TL of canvas at (0,0)
      // aCoords = absolute coordinates that do not need to be updated when zoom or panning change.

      let objProps = {} 
      objProps.beforeScale = {} 
      objProps.beforeScale.aCoords = objs[i].aCoords
      objProps.beforeScale.center = {
        x: (objs[i].aCoords.br.x + objs[i].aCoords.tr.x + objs[i].aCoords.bl.x + objs[i].aCoords.tl.x) / 4, 
        y: (objs[i].aCoords.br.y + objs[i].aCoords.tr.y + objs[i].aCoords.bl.y + objs[i].aCoords.tl.y) / 4
      }
      objProps.beforeScale.centerPercent = {
        x: objProps.beforeScale.center.x / origWidth, 
        y: objProps.beforeScale.center.y / origHeight
      }    
      
      // TESTING 
      // newWindow.document.write('</br>' + 'aCoords Middle before: x:' + objProps.beforeScale.center.x + ' y: ' + objProps.beforeScale.center.y + '</br>')

      // Center of obj will be used for any object not sticky to perimeter
      
      // check which quadrant and also if its within 10% of perimeter
      if (objProps.beforeScale.center.x < origWidth/2 && objProps.beforeScale.center.y < origHeight/2) {
        objProps.quad = 1;
        if (objs[i].aCoords.tl.x < staticThreshold * origWidth) {objProps.posX = false} else {objProps.posX = true}
        if (objs[i].aCoords.tl.y < staticThreshold * origHeight) {objProps.posY = false} else {objProps.posY = true}
      } else if (objProps.beforeScale.center.x > origWidth/2 && objProps.beforeScale.center.y < origHeight/2) {
        objProps.quad = 2;
        if (objs[i].aCoords.tr.x > (origWidth - (staticThreshold * origWidth))) {objProps.posX = false} else {objProps.posX = true}
        if (objs[i].aCoords.tr.y < staticThreshold * origHeight) {objProps.posY = false} else {objProps.posY = true}      
      } else if (objProps.beforeScale.center.x < origWidth/2 && objProps.beforeScale.center.y > origHeight/2) {
        objProps.quad = 3;
        if (objs[i].aCoords.bl.x < staticThreshold * origWidth) {objProps.posX = false} else {objProps.posX = true}
        if (objs[i].aCoords.bl.y > (origHeight - (staticThreshold * origHeight))) {objProps.posY = false} else {objProps.posY = true}      
      } else if (objProps.beforeScale.center.x > origWidth/2 && objProps.beforeScale.center.y > origHeight/2) {
        objProps.quad = 4;
        if (objs[i].aCoords.br.x > (origWidth - (staticThreshold * origWidth))) {objProps.posX = false} else {objProps.posX = true}
        if (objs[i].aCoords.br.y > (origHeight - (staticThreshold * origHeight))) {objProps.posY = false} else {objProps.posY = true}      
      } else {
        objProps.quad = 'center';
        objProps.posX = true; objProps.posY = true;
      }

      //
      // --- SCALE ---
      //

        var scaleX = objs[i].scaleX;
        var scaleY = objs[i].scaleY;

        var tempScaleX = scaleX * scaleXFactor;
        var tempScaleY = scaleY * scaleXFactor;

        // scale
        objs[i].scaleX = tempScaleX;
        objs[i].scaleY = tempScaleY;
    
        // SET NEW COORDINATES OF OBJ AFTER IT HAS BEEN SCALED
        objs[i].setCoords();  
        objProps.afterScale = {}
        objProps.afterScale.aCoords = objs[i].aCoords
        objProps.afterScale.center = {
          x: (objs[i].aCoords.br.x + objs[i].aCoords.tr.x + objs[i].aCoords.bl.x + objs[i].aCoords.tl.x) / 4, 
          y: (objs[i].aCoords.br.y + objs[i].aCoords.tr.y + objs[i].aCoords.bl.y + objs[i].aCoords.tl.y) / 4
        }

        // Target Center
        objProps.afterScale.targetCenter = {
          x: objProps.beforeScale.centerPercent.x * newWidth,
          y: objProps.beforeScale.centerPercent.y * newHeight
        }
      
      //
      // --- POSITION ---
      //

        // POSITION STICK LEFT

          if (objProps.posX) {
            objs[i].left = objProps.afterScale.aCoords.tl.x + (objProps.afterScale.targetCenter.x - objProps.afterScale.center.x)
          } else {
            if (objProps.quad == 1) {
              // do nothing because it's alread shrunk/scaled into top left
            }    
            if (objProps.quad == 2) {
              // newWidth - (space between original and right of canvas) - (width of new object)
              objs[i].left = newWidth - (origWidth - objProps.beforeScale.aCoords.tr.x) - (objProps.afterScale.aCoords.tr.x - objProps.afterScale.aCoords.tl.x)
            }    
            if (objProps.quad == 3) {
              // do nothing because it's already scaled in x direction against "sticky" x side
            }    
            if (objProps.quad == 4) {
              // newWidth - (space between original and right of canvas) - (width of new object)
              objs[i].left = newWidth - (origWidth - objProps.beforeScale.aCoords.br.x) - (objProps.afterScale.aCoords.br.x - objProps.afterScale.aCoords.bl.x)
            }
          }
          
          if (objProps.posY) {
            objs[i].top = objProps.afterScale.aCoords.tl.y + (objProps.afterScale.targetCenter.y - objProps.afterScale.center.y)
          } else {
            if (objProps.quad == 1) {
              // do nothing because it's alread shrunk/scaled into top left (no change in y)
            }    
            if (objProps.quad == 2) {
              // do nothing because it's alread shrunk/scaled into top left
            }    
            if (objProps.quad == 3) {
              // newHeight - (space between original and bottom of canvas) - (height of new object)
              objs[i].top = newHeight - (origHeight - objProps.beforeScale.aCoords.bl.y) - (objProps.afterScale.aCoords.bl.y - objProps.afterScale.aCoords.tl.y)
            }    
            if (objProps.quad == 4) {
              // newHeight - (space between original and bottom of canvas) - (height of new object)
              objs[i].top = newHeight - (origHeight - objProps.beforeScale.aCoords.br.y) - (objProps.afterScale.aCoords.br.y - objProps.afterScale.aCoords.tr.y)
            }
          }

        objs[i].setCoords();
        // TESTING 
        // newWindow.document.write('</br>' + 'aCoords after: ' + JSON.stringify(objs[i].aCoords) + '</br>')    
    }

    resolve();
  });
}
    
function compositeImages() {

    fitCanvas.renderAll();
    fitCanvas.calcOffset();

    var watermark = fitCanvas.toDataURL('image/png', 1)
    var cbk  = callback;

    if (compositeBackgroundImage) {


      //
      // Using new canvas which respects actual size :) 
      // 
      
      // instantiate Fabric canvas
      var compositeCanvas = document.createElement('canvas');
      var ctx = compositeCanvas.getContext('2d');
      // explicitly set dimensions to make sure there's no funny business when loading Fabric JSON obj
      compositeCanvas.width=newWidth
      compositeCanvas.height=newHeight  
      
      // Load sources
      let sources = [];
      sources = [compositeBackgroundImage, watermark]
      const images = sources.map(source => new Promise((resolve, reject) => {
        // Resolve source and img when loaded
        let img = new Image();
        img.onerror = () => reject(new Error('Couldn\'t load image'));
        img.onload = () => resolve(img);
        img.src = source;
      }));
      
      Promise.all(images)
      .then(images => {
        images.forEach(image => {
          return ctx.drawImage(image, 0, 0);
        });  

        var watermarkComposite
        compositeCanvas.toBlob(function(blob) {
          watermarkComposite = URL.createObjectURL(blob);          
          return cbk({watermark, watermarkComposite}) 
        }, 'image/jpeg', outputQuality)         
      })

      //
      // Using fabric export.. fitCanvas.lowerCanvasEl has crazy wrong proporitions and you cannot change them
      //

      /*
      fabric.Image.fromURL(compositeBackgroundImage, function(oImg) {
        oImg.set({ left: 0, top: 0, width: newWidth, height: newHeight});
        fitCanvas.add(oImg);
        fitCanvas.sendToBack(oImg);
        fitCanvas.renderAll();
        // using fabric.lowerCanvasEl.toDataURL to steer clear of Fabric's jank it wraps around the canvas causing performance issues
        // !!!!!
        //  USE THIS FOR dataURL 
        // var watermarkComposite = fitCanvas.lowerCanvasEl.toDataURL('image/jpeg', outputQuality)
        // return cbk({watermark, watermarkComposite}) 
        // !!!!!


        var watermarkComposite
        fitCanvas.lowerCanvasEl.toBlob(function(blob) {
          watermarkComposite = URL.createObjectURL(blob);          
          return cbk({watermark, watermarkComposite}) 
        }, 'image/jpeg', outputQuality)
        
                             
      }, { crossOrigin: 'anonymous' });
      */
      
    } else if (outputType == 'json') {
      var data = fitCanvas.toJSON();  
      return cbk(data)                    
    } else {             
      var data = fitCanvas.toDataURL('image/png', 1); //png by default     
      return cbk(data)               
    }                  
  
  }


}

export { fit };
